export const SET_TRANSACTION = "SET_TRANSACTION";
export const SET_TRANSACTIONS = "SET_TRANSACTIONS";
